import { useState } from 'react'
import { Button } from '@/components/ui/button'

interface AskUserQuestion {
  question: string
  input_type: 'text' | 'buttons' | 'dropdown'
  options?: string[]
}

interface Props {
  question: AskUserQuestion
  answered?: string
  onAnswer: (answer: string) => void
}

export default function AskUserMessage({ question, answered, onAnswer }: Props) {
  const [textValue, setTextValue] = useState('')

  if (answered) {
    return (
      <div className="space-y-2">
        <p className="text-sm text-gray-700">{question.question}</p>
        <div className="rounded-md border border-emerald-100 bg-emerald-50 px-3 py-2 text-sm text-emerald-700">
          {answered}
        </div>
      </div>
    )
  }

  return (
    <div className="space-y-3">
      <p className="text-sm font-medium text-gray-900">{question.question}</p>

      {question.input_type === 'buttons' && question.options && (
        <div className="flex flex-wrap gap-2">
          {question.options.map(option => (
            <Button
              key={option}
              variant="outline"
              size="sm"
              onClick={() => onAnswer(option)}
            >
              {option}
            </Button>
          ))}
        </div>
      )}

      {question.input_type === 'dropdown' && question.options && (
        <select
          className="rounded-md border border-gray-300 px-3 py-2 text-sm"
          defaultValue=""
          onChange={e => {
            if (e.target.value) onAnswer(e.target.value)
          }}
        >
          <option value="" disabled>Select an option...</option>
          {question.options.map(option => (
            <option key={option} value={option}>{option}</option>
          ))}
        </select>
      )}

      {question.input_type === 'text' && (
        <form
          className="flex gap-2"
          onSubmit={e => {
            e.preventDefault()
            if (textValue.trim()) onAnswer(textValue.trim())
          }}
        >
          <input
            type="text"
            value={textValue}
            onChange={e => setTextValue(e.target.value)}
            placeholder="Type your answer..."
            className="flex-1 rounded-md border border-gray-300 px-3 py-2 text-sm outline-none focus:border-emerald-400 focus:ring-1 focus:ring-emerald-400"
            autoFocus
          />
          <Button type="submit" size="sm" disabled={!textValue.trim()}>
            Send
          </Button>
        </form>
      )}
    </div>
  )
}
